/* ============================================================
   AlfaVita™ — Product Page JS
   alfavita-product-page.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Plan Selector ── */
  window.avSelectPlan = function (el) {
    document.querySelectorAll('.av-plan').forEach(function (p) {
      p.classList.remove('selected');
    });
    el.classList.add('selected');

    var variantInput = document.getElementById('av-variant-id');
    if (variantInput) variantInput.value = el.dataset.variantId || '';

    var spInput = document.getElementById('av-selling-plan');
    if (spInput) spInput.value = el.dataset.sellingPlan || '';

    var skuInput = document.getElementById('av-sku');
    if (skuInput) skuInput.value = el.dataset.sku || '';
  };

  /* ── Gallery Switcher ── */
  window.avSwitchGallery = function (thumb, src, alt) {
    document.querySelectorAll('.av-thumb').forEach(function (t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
    var img = document.getElementById('av-main-img');
    if (img) {
      img.style.opacity = '0';
      setTimeout(function () {
        img.src = src;
        img.alt = alt;
        img.style.opacity = '1';
      }, 120);
    }
  };

  /* ── FAQ Accordion ── */
  window.avToggleFaq = function (el) {
    var item = el.closest('.av-faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.av-faq-item.open').forEach(function (i) {
      i.classList.remove('open');
      var toggle = i.querySelector('.av-faq-toggle');
      if (toggle) toggle.textContent = '+';
    });
    if (!isOpen) {
      item.classList.add('open');
      var toggle = el.querySelector('.av-faq-toggle');
      if (toggle) toggle.textContent = '\u2212';
    }
  };

  /* ── Cart Add ── */
  function avAddToCart() {
    var variantInput = document.getElementById('av-variant-id');
    var id = variantInput ? parseInt(variantInput.value, 10) : 0;
    if (!id) { console.error('AV: variant ID missing'); return; }

    var btn = document.getElementById('av-btn-cart');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando\u2026'; }

    var sku = (document.getElementById('av-sku') || {}).value || '';
    var sellingPlan = parseInt((document.getElementById('av-selling-plan') || {}).value, 10) || 0;
    var freeGiftId = parseInt((document.getElementById('av-freegift-variant-id') || {}).value, 10) || 0;

    console.log('AV add-to-cart → variant:', id, 'sellingPlan:', sellingPlan, 'sku:', sku, 'freeGift:', freeGiftId);

    function reset() {
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
    }

    function goCheckout() {
      window.location.href = '/checkout';
    }

    // Step 1: clear cart — then add plan + free gift in one single request
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .catch(function () {})
      .then(function () {
        var items = [{ id: id, quantity: 1, selling_plan: sellingPlan || undefined, properties: { _sku: sku } }];
        if (freeGiftId) items.push({ id: freeGiftId, quantity: 1, properties: { _gift: 'FREEGIFT' } });

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) {
          console.error('AV add error:', data.status, data.description);
          reset();
          return;
        }
        goCheckout();
      })
      .catch(function (err) {
        console.error('AV fetch error:', err);
        reset();
      });
  }

  /* ── avAddToCart is called directly via onclick on the button ── */
  window.avAddToCart = avAddToCart;

  /* ── Re-enable button when restored from bfcache (browser back) ── */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      var btn = document.getElementById('av-btn-cart');
      if (btn) { btn.disabled = false; btn.textContent = 'COMENZAR MI PRUEBA'; }
    }
  });

  /* ── Init (safe: works whether DOMContentLoaded has fired or not) ── */
  function avInit() {
    var plans = document.querySelectorAll('.av-plan');
    var defaultPlan = plans[1] || plans[0];
    if (defaultPlan) avSelectPlan(defaultPlan);

    var firstFaq = document.querySelector('.av-faq-item');
    if (firstFaq) {
      firstFaq.classList.add('open');
      var toggle = firstFaq.querySelector('.av-faq-toggle');
      if (toggle) toggle.textContent = '\u2212';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avInit);
  } else {
    avInit();
  }

})();
